import axios from 'axios';

// const urlApi = (window as any).globalConfig.URL_API
//   ? (window as any).globalConfig.URL_API
//   : '';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_CONECTOGO_URL_API}${process.env.REACT_APP_CONECTOGO_URL_API_PATH}`,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
  withCredentials: true,
});

// Add a response interceptor
api.interceptors.response.use(
  function (response) {
    // Do something with response data
    //konsole.log('api.interceptors.response: ', response);
    return response;
  },
  function (error) {
    // Do something with response error
    //konsole.log('api.interceptors.response->status: ', error.response.status)
    //konsole.log('api.interceptors.response->error: ', error);
    return Promise.reject(error);
  },
);

export default api;
